module.exports = __webpack_public_path__ + "img/TULA.9b780561.png";